// Pure helper for blog scroll depth (spec §4). Testable without a DOM.
// Returns the deepest-scrolled percent (0..100). A page that fits the viewport
// counts as fully read (100).
export const computeScrollPercent = (scrollY, viewportHeight, docHeight) => {
  const y = Number(scrollY), vh = Number(viewportHeight), dh = Number(docHeight);
  if (!Number.isFinite(y) || !Number.isFinite(vh) || !Number.isFinite(dh)) return 0;
  const scrollable = dh - vh;
  if (scrollable <= 0) return 100;
  return Math.max(0, Math.min(100, Math.round((y / scrollable) * 100)));
};
